// extracted by mini-css-extract-plugin
export default {"title":"PublishPaper_title__WbvN7","publish-details":"PublishPaper_publish-details__FRf2B","view-btn":"PublishPaper_view-btn__XgNWB","creator":"PublishPaper_creator__6xfHJ"};